import Constants from "../Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

class ForgotPasswordActions {

  public request(user): ActionInterface {
    return {
      type: Constants.PAGE_FORGOT_PASSWORD_REQUEST,
      payload: {
        user
      }
    };
  }

  public success(user): ActionInterface {
    return {
      type: Constants.PAGE_FORGOT_PASSWORD_SUCCESS,
      payload: {
        user
      }
    };
  }

  public failure(err): ActionInterface {
    return {
      type: Constants.PAGE_FORGOT_PASSWORD_FAILURE,
      payload: {
        err
      }
    };
  }

  public openPopup(message): ActionInterface {
    return {
      type: Constants.PAGE_FORGOT_PASSWORD_OPEN_POPUP,
      payload: {
        message
      }
    };
  }

  public closePopup(): ActionInterface {
    return {
      type: Constants.PAGE_FORGOT_PASSWORD_CLOSE_POPUP
    };
  }
}

export default new ForgotPasswordActions();
